import React from 'react';
import { Menu, Typography, Layout } from 'antd';
import { Route, Switch, useHistory, useParams } from 'react-router-dom';
import RoleHierarchyDepartmentContent from './roleHierarchy/RoleHierarchyDepartmentContent';
import RoleHierarchySchoolContent from './roleHierarchy/RoleHieratchySchoolContent';
import RoleHierarchyNauContent from './roleHierarchy/RoleHierarchyNauContent';
import RoleHierarchyFacultyContent from './roleHierarchy/RoleHierarchyFacultyContent';

const { Text } = Typography;
const { Content, Sider } = Layout;

const TabRoleHierarchy = () => {
  const { id, type } = useParams();
  const history = useHistory();

  return (
    <Layout>
      <Sider width={160} className="site-layout-background">
        <Menu
          onClick={(e) => {
            history.push(
              `/system-setting/project-categories/${id}/role-hierarchy/${e.key}`
            );
          }}
          style={{ width: 160, height: '100%', alignSelf: 'stretch' }}
          defaultSelectedKeys={[type]}
          mode="inline"
        >
          <Menu.Item key="department">Department</Menu.Item>
          <Menu.Item key="faculty">Faculty</Menu.Item>
          <Menu.Item key="school">School</Menu.Item>
          <Menu.Item key="nau">NAU</Menu.Item>
        </Menu>
      </Sider>
      <Layout style={{ backgroundColor: '#fff', padding: '0 24px 24px' }}>
        <Content
          style={{
            backgroundColor: '#fff',
            padding: 24,
          }}
        >
          <Text
            type="secondary"
            style={{ display: 'block', paddingBottom: '16px' }}
          >
            Role Hierarchy (The lower the sequence number, the higher level in
            the hierarchy
          </Text>
          <Switch>
            <Route
              exact
              path={`/system-setting/project-categories/:id/role-hierarchy/department`}
            >
              <RoleHierarchyDepartmentContent />
            </Route>
            <Route
              exact
              path={`/system-setting/project-categories/:id/role-hierarchy/nau`}
            >
              <RoleHierarchyNauContent />
            </Route>
            <Route
              exact
              path={`/system-setting/project-categories/:id/role-hierarchy/school`}
            >
              <RoleHierarchySchoolContent />
            </Route>
            <Route
              exact
              path={`/system-setting/project-categories/:id/role-hierarchy/faculty`}
            >
              <RoleHierarchyFacultyContent />
            </Route>
          </Switch>
        </Content>
      </Layout>
    </Layout>
  );
};

export default TabRoleHierarchy;
